import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

import ListContext from './ListContext';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './List.scss';

function List(props) {
    const {
        className,
        classes: classesProp = {},
        component: Component = 'ul',
        componentProps,
        disablePadding = false,
        spacing = 2,
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    const context = React.useMemo(() => ({ spacing }), [spacing]);

    return (
        <ListContext.Provider value={context}>
            <Component
                className={clsx(
                    classes.root,
                    { [classes.disablePadding]: disablePadding },
                    className,
                )}
                {...otherProps}
                {...componentProps}
            />
        </ListContext.Provider>
    );
}

List.propTypes = {
    /**
     * The content of the list.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * The component used for the root node.
     * Either a string to use a HTML element or a component.
     */
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    /**
     * If `true`, vertical padding will be removed from the list.
     */
    disablePadding: PropTypes.bool,
    /**
     * Defines the gutter size of n * the base spacing size between the list parts in <ListItem />.
     */
    spacing: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),

};

export default List;
